import { AnimatePresence, motion } from 'framer-motion';

interface GenerationFailedDialogProps {
  isOpen: boolean;
  onClose: () => void;
}

export const GenerationFailedDialog = ({ isOpen, onClose }: GenerationFailedDialogProps) => {
  return (
    <AnimatePresence>
      {isOpen && (
        <>
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 bg-black/50 z-50"
            onClick={onClose}
          />
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.95 }}
            className="fixed inset-0 flex items-center justify-center z-50 p-4 pointer-events-none"
          >
            <div 
              className="bg-white dark:bg-gray-800 rounded-lg shadow-xl max-w-md w-full p-6 pointer-events-auto"
              onClick={(e) => e.stopPropagation()}
            >
              <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-3">
                Generation Failed
              </h3>
              <p className="text-gray-600 dark:text-gray-400 mb-6">
                We couldn't generate your game with AI. Don't worry - we've set up a blank template so you can start building manually or try again with AI assistance.
              </p>
              <button
                onClick={onClose}
                className="w-full py-2 px-4 bg-gradient-to-r from-purple-600 to-pink-600 text-white rounded-lg hover:opacity-90 transition-opacity"
              >
                Got it
              </button>
            </div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
};

